<template>
  <div class="container">
    <QueryFrame
      :add-text="handlePermission('headOfficeProceedsTypeAdd')?'新建付款方式':''"
      :count="count"
      :current="page"
      @addNew="addNew"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>付款方式名称:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.name"></lk-input>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker type='daterange' v-model="query.duration" class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>创建人:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable
                      v-model.trim="query.userName"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <!-- 新建付款方式 开始 -->
    <lk-modal
      v-model="editModal.visiable"
      :mask-closable="false"
      title="新建付款方式"
      @on-cancel="cancelEdit">
      <lk-form
        label-position="right"
        :label-width="134"
        :rules="formRules"
        :model="formModel"
        ref="form">
        <div class="modalContainer">
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="付款方式名称:" prop="name">
                <lk-input
                  :maxlength="100"
                  placeholder="请输入"
                  class="item"
                  clearable
                  v-model.trim="formModel.name">
                </lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </div>
      </lk-form>
      <div slot="footer">
        <div>
          <lk-button @click="cancelEdit">取消</lk-button>
          <lk-button type="primary" @click="handleSave" :loading="editModal.loading">提交</lk-button>
        </div>
      </div>
    </lk-modal>
    <!-- 新建付款方式 结束 -->
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import systemService from '../../services/system';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'headOfficeProceedsType',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      params: {},
      query: {
        name: null,
        duration: null,
        userName: null,
      },
      editModal: {
        visiable: false,
        loading: false,
      },
      formModel: {
        name: '',
      },
      formRules: {
        name: [
          { required: true, message: '请输入名称' },
          { validator: this.nameExistValidator, trigger: 'blur' },
        ],
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '付款方式名称',
          key: 'name',
          minWidth: 116,
        },
        {
          title: '创建时间',
          key: 'createTimeStr',
          minWidth: 116,
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 116,
        },
        {
          title: '启用门店',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'proceedsTypeInfo',
                    params: {
                      id: row.id,
                    },
                  });
                },
              },
            }, '查看'),
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration && this.params.duration.length === 2) {
        this.params.startTime = this.params.duration[0];
        this.params.endTime = this.params.duration[1];
        delete this.params.duration;
      }

      systemService.getHeadOfficePayWayList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          list.forEach((item) => {
            item.createTimeStr = utils.exchangeTime(item.createTime); // 创建时间
          });
          this.count = count;
          this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNew() {
      this.editModal.visiable = true;
    },
    cancelEdit() {
      this.$refs.form.resetFields();
      this.editModal.visiable = false;
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.commit('setDisableLoading', true);
          const params = {
            name: this.formModel.name,
          };

          this.editModal.loading = true;
          systemService.proceedsTypeSave(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('添加成功');
              this.editModal.visiable = false;
              this.getData();
            } else {
              this.$Message.error(res.data.error);
            }
            this.editModal.loading = false;
          }).catch((err) => {
            this.editModal.loading = false;
            utils.handleError(err);
          });
        } else {
          this.$Message.error(' 请按照要求填写');
        }
      });
    },
    nameExistValidator(rule, value, callback) {
      this.$store.commit('setDisableLoading', true);
      systemService.isProceedsTypeNameExist({ name: value }).then((res) => {
        if (res.data.status === 200) {
          callback();
        } else {
          callback(new Error(res.data.error));
        }
      }).catch((err) => {
        utils.handleError(err);
        callback();
      });
    },
  },
  mounted() {
    this.handleSearch(true);

    if (!this.handlePermission('proceedsTypeInfo')) {
      this.columns.pop();
    }
  },
};
</script>
<style lang="less" scoped>
</style>
